import template from './glassButton.template.html';
import templateDialog from './glassDialog.template.html';

export default {
  template,
  bindings: {
    asset: '<',
    isDisabled: '<',
    isCommercial: '<',
    onChange: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdMedia,
      $mdDialog,
      glassService,
      uiService,
      eventService,
      GLASS
    ) {
      'ngInject';

      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.isOpenDialog = false;
        ctrl.asset = ctrl.asset || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      this.openDialog = ($event) => {
        $event.stopPropagation();

        $mdDialog
          .show({
            locals: {},
            template: templateDialog,
            multiple: true,
            clickOutsideToClose: false,
            controllerAs: '$ctrl',
            controller() {
              const self = this;

              self.availableYears = [];
              self.availableYearsTo = [];
              self.availableMakes = [];
              self.availableModels = [];
              self.availableSeries = [];
              self.availableVariants = [];
              self.availableListOfVehicles = [];
              self.availableListOfOptionsForNvic = [];
              self.choosenListOfOptionsForNvic = [];
              self.availableKMAdjustmentByNVIC = [];
              self.asset = ctrl.asset;
              self.actualKilometers = ctrl.asset.vehicle.kilometers;
              self.vehicleDetails = null;
              self.searchStarted = false;
              self.isImporting = false;
              self.showSummary = false;
              self.currentCurrency = $rootScope.CurrentCurrency();
              self.availableModelCodeTypes = Object.keys(GLASS.MODEL_TYPE_CODE)
                .filter((key) => (key === 'HEAVY_COMMERICAL' ? ctrl.isCommercial : true))
                .map((key) => ({
                  id: GLASS.MODEL_TYPE_CODE[key],
                  value: key.sanitize().capitalizeFirstLetter()
                }));

              self.modelTypeCode = ctrl.mapModelTypeCode(self.asset.type);

              self.kilometerAdjustment = 0;
              self.retailPrice = 0;

              self.searchQuery = {
                yearFrom: 0,
                yearTo: 0,
                manufacturerCode: '',
                familyCode: '',
                variantName: '',
                seriesCode: ''
              };

              self.initialize = () => {
                self.loadYears();
              };

              /*
               * Events
               * --------------------------------------------------------------------------------
               */
              self.onYearFromSelected = (year) => {
                self.resetYearsTo();
                self.resetMakes();
                self.resetModels();
                self.resetVariants();
                self.resetSeries();

                self.loadYearsTo(year);
              };

              self.onYearToSelected = () => {
                self.resetMakes();
                self.resetVariants();
                self.resetSeries();
                self.loadMakes();
              };

              self.onMakeSelected = () => {
                self.resetModels();
                self.resetVariants();
                self.resetSeries();
                self.loadModels();
              };

              self.onModelSelected = () => {
                self.resetVariants();
                self.resetSeries();
                self.loadVariants();
              };

              self.onVariantSelected = () => {
                self.resetSeries();
                self.loadSeries();
              };

              /*
               * Can Select methods
               * --------------------------------------------------------------------------------
               */
              self.canSelectMakes = () =>
                self.availableMakes.length &&
                self.searchQuery.yearFrom &&
                self.searchQuery.yearTo;

              self.canSelectModels = () => self.availableModels.length && self.canSelectMakes();

              self.canSelectVariants = () =>
                self.availableVariants.length && self.canSelectModels();

              self.canSelectSeries = () =>
                self.availableSeries.length && self.canSelectVariants();

              /*
               * Reset data methods
               * --------------------------------------------------------------------------------
               */
              self.resetYearsTo = () => {
                self.availableYearsTo = [];
                self.searchQuery.yearTo = 0;
              };

              self.resetModels = () => {
                self.availableModels = [];
                self.searchQuery.familyCode = '';
              };

              self.resetVariants = () => {
                self.searchQuery.variantName = '';
                self.availableVariants = [];
              };

              self.resetMakes = () => {
                self.availableMakes = [];
                self.searchQuery.manufacturerCode = '';
              };

              self.resetSeries = () => {
                self.searchQuery.seriesCode = '';
                self.availableSeries = [];
              };

              self.resetListOfVehicles = () => {
                self.availableListOfVehicles = [];
              };

              /*
               * Load Data methods
               * --------------------------------------------------------------------------------
               */
              self.loadYears = () => {
                glassService
                  .search({ type: GLASS.REQUEST_TYPE.LIST_OF_YEARS })
                  .then((response) => {
                    if (!response || !response.length) {
                      self.displayError();
                    }
                    self.availableYears = response.map((year) => Number(year));
                  });
              };

              self.loadYearsTo = (year) => {
                self.availableYearsTo = self.limitToThreeYearsInAdvance(year);
              };

              self.loadMakes = () => {
                self.resetModels();
                glassService
                  .search({
                    modelTypeCode: self.modelTypeCode,
                    type: GLASS.REQUEST_TYPE.LIST_OF_MAKES_YEAR_FROM_TO,
                    ...self.searchQuery
                  })
                  .then((response) => {
                    if (!response || !response.length) {
                      self.displayError();
                    }
                    self.availableMakes = response;
                  });
              };

              self.loadModels = () => {
                glassService
                  .search({
                    modelTypeCode: self.modelTypeCode,
                    type: GLASS.REQUEST_TYPE.LIST_OF_MODELS_YEAR_FROM_TO,
                    ...self.searchQuery
                  })
                  .then((response) => {
                    if (!response || !response.length) {
                      self.displayError();
                    } else {
                      self.availableModels = response;
                    }
                  });
              };

              self.loadVariants = () => {
                glassService
                  .search({
                    modelTypeCode: self.modelTypeCode,
                    type: GLASS.REQUEST_TYPE.LIST_OF_VARIANTS_YEAR_FROM_TO,
                    ...self.searchQuery
                  })
                  .then((response) => {
                    if (!response || !response.length) {
                      self.displayError();
                    } else {
                      self.availableVariants = response;
                    }
                  });
              };

              self.loadSeries = () => {
                glassService
                  .search({
                    modelTypeCode: self.modelTypeCode,
                    type: GLASS.REQUEST_TYPE.LIST_OF_SERIES_YEAR_FROM_TO,
                    ...self.searchQuery
                  })
                  .then((response) => {
                    if (!response || !response.length) {
                      self.displayError();
                    } else {
                      self.availableSeries = response;
                    }
                  });
              };

              self.loadListOfVehicles = () => {
                self.resetListOfVehicles();
                self.searchStarted = true;

                const range = _.range(self.searchQuery.yearFrom, self.searchQuery.yearTo + 1);
                $q.all(
                  range.map((year) =>
                    glassService.search({
                      modelTypeCode: self.modelTypeCode,
                      type: GLASS.REQUEST_TYPE.LIST_OF_NVICFOR_ADVANCED_SEARCH,
                      ...self.searchQuery,
                      yearCreate: year
                    })
                  )
                ).then((response) => {
                  self.searchStarted = false;
                  self.availableListOfVehicles = [
                    ...(response[0] || []),
                    ...(response[1] || []),
                    ...(response[2] || [])
                  ];

                  if (!self.availableListOfVehicles.length) {
                    self.displayError();
                  }
                });
              };

              self.selectVehicle = async (vehicleShort) => {
                self.showSummary = true;
                self.searchStarted = true;

                try {
                  self.vehicleDetails = await glassService.search({
                    type: GLASS.REQUEST_TYPE.DETAILS_SPECIFICATION_ALL,
                    modelTypeCode:
                      self.modelTypeCode !==
                      GLASS.MODEL_TYPE_CODE.CARAVANS_CAMPERVANS_MOTORHOMES
                        ? GLASS.MODEL_TYPE_CODE.ALL_VEHICLES
                        : GLASS.MODEL_TYPE_CODE.CARAVANS_CAMPERVANS_MOTORHOMES,
                    nVic: vehicleShort.nVicCur,
                    ...self.searchQuery
                  });

                  if (!self.vehicleDetails || !Object.keys(self.vehicleDetails).length) {
                    self.displayError();
                  }

                  if (self.vehicleDetails.ClassCode) {
                    self.availableKMAdjustmentByNVIC = await glassService.search({
                      type: GLASS.REQUEST_TYPE.GET_KM_ADJUSTMENT_BY_NVIC,
                      nVic: vehicleShort.nVicCur
                    });
                  } else {
                    self.availableKMAdjustmentByNVIC = [];
                  }

                  self.availableListOfOptionsForNvic = await glassService
                    .search({
                      type: GLASS.REQUEST_TYPE.LIST_OF_OPTIONS_FOR_NVIC,
                      ...self.searchQuery,
                      nVic: vehicleShort.nVicCur
                    })
                    .then((options) => {
                      const opts = _.map(options, (op) => ({
                        ...op,
                        details: {
                          adjust_retail: 0,
                          adjust_trade: 0,
                          adjust_trade_low: 0
                        }
                      }));
                      _.forEach(opts, async (op) => {
                        op.details = await glassService
                          .search({
                            type: GLASS.REQUEST_TYPE.GET_OPTIONS_VALUE,
                            classCode: self?.vehicleDetails?.ClassCode,
                            makeCode: self?.searchQuery?.manufacturerCode,
                            familyCode: self?.searchQuery?.familyCode,
                            yearCreate: self?.vehicleDetails?.YearCreate,
                            optionCode: op.code
                          })
                          .then((r) => _.head(r));
                      });
                      return opts;
                    });

                  self.retailPrice =
                    Number(
                      ctrl.asset.age === 1
                        ? self.vehicleDetails.RRP
                        : self.vehicleDetails.Retail
                    ) || 0;

                  if (self.vehicleDetails.DealerRetail) {
                    const dealerRetail = self.vehicleDetails.DealerRetail.split(' - ').map(
                      (price) => Number(parseFloat(price).toFixed())
                    );
                    const low = dealerRetail[0];
                    const high = dealerRetail[1];
                    self.dealerRetail = (low + high) / 2;
                    self.calculatedPrice = self.dealerRetail;
                  } else {
                    const { price, adjusted } = self.calculatePrice({
                      averageKm: Number(self.vehicleDetails.AverageKM) || 0,
                      actualKm: Number(self.actualKilometers),
                      age: self.age,
                      retailPrice: self.retailPrice,
                      availableKMAdjustmentByNVIC: self.availableKMAdjustmentByNVIC
                    });
                    self.calculatedPrice = price;
                    self.kilometerAdjustment = adjusted;
                  }
                } catch (e) {
                  $mdDialog.hide({ assetInfo: null });
                }

                self.searchStarted = false;
              };

              self.calculatePrice = ({
                averageKm,
                actualKm = 0,
                retailPrice,
                availableKMAdjustmentByNVIC = []
              }) => {
                try {
                  if (actualKm === 0) {
                    return { price: retailPrice, adjusted: 0 };
                  }
                  const underOverKms = Math.round((averageKm - actualKm) / 1000) * 1000;
                  const isUnder = underOverKms < 0;
                  let adjustmentBracket = _.find(
                    availableKMAdjustmentByNVIC,
                    ({ variationFromAvgKm }) =>
                      parseInt(variationFromAvgKm, 10) === parseInt(Math.abs(underOverKms), 10)
                  );
                  if (!adjustmentBracket) {
                    const brackets = _.sortBy(availableKMAdjustmentByNVIC, (b) =>
                      Math.abs(b.variationFromAvgKm)
                    );
                    adjustmentBracket = _.last(brackets);
                  }
                  const adjustmentByBracket = _.get(adjustmentBracket, 'amount', 0);
                  const adjusted = isUnder
                    ? parseFloat(adjustmentByBracket)
                    : Math.abs(adjustmentByBracket);
                  const price = retailPrice + adjusted;
                  return { price, adjusted };
                } catch (e) {
                  return { price: retailPrice, adjusted: 0 };
                }
              };

              self.exists = (list, option) => list.some(({ name }) => option.name === name);
              self.remove = (list, option) =>
                _.reject(list, ({ name }) => name === option.name);
              self.add = (list, option) => _.concat(list, option);

              self.optionPrice = (option) =>
                ctrl.asset.age === 1
                  ? Number(parseFloat(option.value).toFixed())
                  : Number(option.details.adjust_retail);

              self.addOptionToCost = (option) => {
                if (self.exists(self.choosenListOfOptionsForNvic, option)) {
                  self.choosenListOfOptionsForNvic = self.remove(
                    self.choosenListOfOptionsForNvic,
                    option
                  );
                  self.calculatedPrice -= self.optionPrice(option);
                  return;
                }
                self.choosenListOfOptionsForNvic = self.add(
                  self.choosenListOfOptionsForNvic,
                  option
                );
                self.calculatedPrice += self.optionPrice(option);
              };

              self.importVehicle = () => {
                $mdDialog.hide({
                  assetInfo: self.vehicleDetails,
                  options: self.choosenListOfOptionsForNvic,
                  calculatedPrice: self.calculatedPrice
                });
              };

              /*
               * Helpers
               * --------------------------------------------------------------------------------
               */
              self.limitToThreeYearsInAdvance = (year) => {
                const index = self.availableYears.indexOf(year);
                const endYearIndex = Math.max(index - 3, 0);
                const startYearIndex = index || 1;

                return self.availableYears.slice(endYearIndex, startYearIndex);
              };

              self.displayError = () => {
                uiService.toast({
                  text: {
                    p1: 'Error happened while connecting',
                    p2: 'or data does not exist',
                    p3: "in Glass's service"
                  },
                  warn: true
                });
              };

              self.reset = () => {
                self.resetYearsTo();
                self.resetMakes();
                self.resetModels();
                self.resetVariants();
                self.resetSeries();
                self.resetListOfVehicles();

                self.searchQuery.yearFrom = 0;
              };

              self.canSearch = () =>
                self.availableYears.length &&
                self.availableYearsTo.length &&
                self.availableMakes.length &&
                self.availableModels.length &&
                self.searchQuery.manufacturerCode &&
                self.searchQuery.familyCode;

              self.search = () => {
                self.availableListOfOptionsForNvic = [];
                self.availableKMAdjustmentByNVIC = [];
                self.vehicleDetails = null;
                self.loadListOfVehicles();
              };

              self.cancel = () => {
                $mdDialog.hide(false);
              };

              self.back = () => {
                self.showSummary = false;
                self.kilometerAdjustment = 0;
                self.retailPrice = 0;
                self.calculatedPrice = 0;
                self.vehicleDetails = null;
                self.availableKMAdjustmentByNVIC = [];
                self.choosenListOfOptionsForNvic = [];
              };

              self.initialize();
            }
          })
          .then(({ assetInfo, options = [], calculatedPrice } = {}) => {
            if (assetInfo) {
              ctrl.asset.vehicle.year = Number(assetInfo.YearCreate) || ctrl.asset.vehicle.year;
              ctrl.asset.vehicle.make = assetInfo.ManufacturerName || ctrl.asset.vehicle.make;
              ctrl.asset.vehicle.model = assetInfo.ModelName;
              ctrl.asset.vehicle.variant = assetInfo.VariantName || ctrl.asset.vehicle.variant;
              ctrl.asset.vehicle.series = assetInfo.SeriesName || ctrl.asset.vehicle.series;
              ctrl.asset.vehicle.transmission =
                assetInfo.TransmissionName || ctrl.asset.vehicle.transmission;
              ctrl.asset.vehicle.nvic = assetInfo.NVIC_CUR || ctrl.asset.vehicle.nvic;
              ctrl.asset.costInfo = calculatedPrice;

              ctrl.asset.vehicle.kilometersInfo =
                Number(assetInfo.AverageKM) || ctrl.asset.vehicle.kilometers;
              ctrl.asset.vehicle.engine = assetInfo.EngineName || ctrl.asset.vehicle.engine;
              ctrl.asset.vehicle.type =
                ctrl.mergeVehicleType(assetInfo.BodyName) || ctrl.asset.vehicle.type;
              ctrl.asset.type = assetInfo.ClassCode === 'PAS' ? 1 : ctrl.asset.type;

              /**
               * Additional Info
               */
              ctrl.asset.additionalInfo.glass = [
                ..._.reject(
                  ctrl.asset.additionalInfo,
                  ({ type }) => type === 'glass' || type === 'info'
                ),
                ...options,
                { name: 'CC Name', value: assetInfo.CCName, type: 'glass' },
                { name: 'Private Sale', value: assetInfo.PrivateSale, type: 'glass' },
                { name: 'Dealer Retail', value: assetInfo.DealerRetail, type: 'glass' },
                { name: 'Dealer Trade', value: assetInfo.DealerTrade, type: 'glass' },
                { name: 'RPP', value: assetInfo.RRP, type: 'glass' },
                { name: 'VINNumber', value: assetInfo.VINNumber, type: 'glass' },
                { name: 'Segment Name', value: assetInfo.SegmentName, type: 'glass' },
                {
                  name: 'Engine Config Name',
                  value: assetInfo.Engine_ConfigName,
                  type: 'glass'
                },
                { name: 'No Of Doors', value: assetInfo.NoOfDoors, type: 'glass' },
                { name: 'Height', value: assetInfo.Height, type: 'glass' },
                { name: 'Length', value: assetInfo.Length, type: 'glass' },
                { name: 'Width', value: assetInfo.Width, type: 'glass' },
                { name: 'Tow Cap Braked', value: assetInfo.TowCapBraked, type: 'glass' },
                { name: 'Tow Cap Un Braked', value: assetInfo.TowCapUnBraked, type: 'glass' },
                { name: 'Kerb Weight', value: assetInfo.KerbWeight, type: 'glass' },
                { name: 'No Of Seats', value: assetInfo.NoOfSeats, type: 'glass' },
                {
                  name: 'Driven Wheels Name',
                  value: assetInfo.DrivenWheelsName,
                  type: 'glass'
                },
                { name: 'Fuel Name', value: assetInfo.FuelName, type: 'glass' },
                { name: 'Capacity', value: assetInfo.Capacity, type: 'glass' },
                { name: 'City Consumption', value: assetInfo.CityConsumption, type: 'glass' },
                {
                  name: 'Highway Consumption',
                  value: assetInfo.HighwayConsumption,
                  type: 'glass'
                },
                { name: 'Service Months', value: assetInfo.Service_Months, type: 'glass' },
                { name: 'Service KMS', value: assetInfo.Service_KMS, type: 'glass' },
                { name: 'Warranty KMS', value: assetInfo.WarrantyKMS, type: 'glass' },
                { name: 'Warranty Months', value: assetInfo.WarrantyMonths, type: 'glass' }
              ];
            }
            eventService.assetDetailsAdditionalInfo();
            ctrl.onFinished({ status: true });
          });
      };

      ctrl.mapModelTypeCode = (type) => {
        switch (type) {
          case 1:
          case 2:
          case 3:
            return 'APAS';
          case 4:
          case 6:
          case 7:
            return 'ALCV';
          case 8:
          case 9:
          case 10:
            return 'AHCV';
          default:
            return 'A';
        }
      };

      ctrl.mergeVehicleType = (bodyName = '') => {
        const name = bodyName.toUpperCase();

        if (name.includes('SEDAN') || name.includes('2D') || name.includes('3D')) {
          return 1;
        }
        if (name.includes('WAGON') || name.includes('WAN')) {
          return 2;
        }
        if (name.includes('4WD')) {
          return 3;
        }
        return null;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };
      ctrl.$onChanges = () => {
        ctrl.initialize();
      };
    }
  }
};
